export default __webpack_public_path__ + "static/media/02-model.60bd1820.gif";